import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=5d4dd8ec&scoped=true&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4dd8ec",
  null
  
)

export default component.exports